import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const url = "https://mfhdaiymdtwhsnaximji.supabase.co";

const anon = 
  (import.meta.env.VITE_SUPABASE_ANON_KEY ||
   import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1maGRhaXltZHR3aHNuYXhpbWppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYzMTE1MDUsImV4cCI6MjA3MTg4NzUwNX0.E-Mrze3hhKxO5hTf-j4iYa1v4AIdIs8zicdUjNatcRA") as string; // support both names

export const supabase = createClient<Database>(url, anon, {
  auth: { persistSession: false },
});